// extracted by mini-css-extract-plugin
module.exports = {"left":"_d996b1d7","center":"_aeccdbac"};